module.exports = __webpack_public_path__ + "static/3-3ef26a5a51a5e2052f64d92e25d9bfa3.jpeg";